import {
  LetterbookSettingType,
  LetterbookType,
} from "features/Letterbooks/types";
import LetterbookColumn from "./columns/LetterbookColumn";

export default function LetterbookTableRow({
  letterbook,
  settings,
}: {
  letterbook: LetterbookType;
  settings: LetterbookSettingType;
}) {
  const { tableColumns } = settings;

  return (
    <tr className="bg-gray-100 dark:bg-gray-900">
      {tableColumns.map((column) => (
        <LetterbookColumn
          key={column.key}
          column={column}
          letterbook={letterbook}
          settings={settings}
        />
      ))}
    </tr>
  );
}
